var map = {
	"./ar.json": [
		5868,
		5868
	],
	"./es.json": [
		5187,
		5187
	],
	"./fr.json": [
		7791,
		7791
	],
	"./pt.json": [
		9087,
		9087
	],
	"./zh.json": [
		3413,
		3413
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2251;
module.exports = webpackAsyncContext;